/* PeRsonalIsed System for interaCtIve (programming) Learning and Learning Assistance */
<template>
  <div>
<!--     <div v-if="!initialised">{{checkVersion()}}</div>
 --> <v-app-bar app dense>

      <v-app-bar-nav-icon @click.stop="mobileNavigation=!mobileNavigation" v-if="isLogged" class="mobile-navigation-icon"></v-app-bar-nav-icon>

      <span @click="priscilla()" class="logo" :style="{ backgroundImage: 'url(' + require('@/assets/priscilla-logo'+logoThemeVersion+'.svg') + ')' }"></span>
      <v-toolbar-title class="mobile-hidden">
        <v-chip @click="priscilla()" > <small>{{version}} </small></v-chip>
      </v-toolbar-title>
      <v-spacer></v-spacer>
  
      <v-toolbar-items>
        <!-- ps: pridal som class a color  -->
        <v-btn @click="register()" small class="app-bar-item mobile-hidden" v-if="!isLogged">Register</v-btn>
        <v-btn @click="login()" small class="app-bar-item mobile-hidden" v-if="!isLogged">Login</v-btn>
        <v-btn @click="dashboard()" small class="app-bar-item mobile-hidden" v-if="isLogged"> DashBoard</v-btn>
        <v-btn @click="categories()" small class="app-bar-item mobile-hidden" v-if="isLogged">Course list</v-btn>
        
        <!-- SS : VS switch -->
<!--         <div class="user-type-switch" v-if="isLogged">
            <img src="@/assets/img/icons/ziak.svg" :class="typeStudentSwitch ? '' : 'active'" alt="icon">
            <v-switch v-model="typeStudentSwitch" inset></v-switch>
            <img src="@/assets/img/icons/student.svg" :class="typeStudentSwitch ? 'active' : ''" alt="icon">
        </div> -->

      <!-- jazyk -->
      <v-menu class="lang-wrapper" offset-y  v-if="isLogged && user">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none">
              <img class="lang-icon" :src="getLanguageURL()"/> {{ getLanguageTitle() }}
            </v-btn>
          </template>
          <v-list nav dense>
            <v-list-item-group>
              <v-list-item v-for="(language, index) in getLanguageIcons" :key="index" @click="langClick(language.title)">
                <img class="lang-icon" :src="language.url"/>
                <v-list-item-title >{{ language.title }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
      </v-menu>
      <!-- jazyk -->

        <v-chip v-if="getUserPerformance && isLogged"
                class="ma-2 mobile-hidden"
                color="orange"
                text-color="white"
              >{{getUserPerformance.xp}} XP
        </v-chip>
        
        <v-chip v-if="getUserPerformance && isLogged"
                class="ma-2 mobile-hidden"
                color="orange"
                text-color="white"
              >
              <v-icon left>tonality</v-icon>
              {{getUserPerformance.coins}}          
        </v-chip>
       <!--  <v-btn v-if="isLogged" small class="white--text" color="buttonColor" @click="logout">Logout</v-btn> -->
        
      </v-toolbar-items>

      <v-menu
          v-if = "isLogged"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon v-on="on" class="mobile-hidden"></v-app-bar-nav-icon>             
          </template>
        
        <v-card class="v-app-bar__desktop-nav">
          <v-list class="desktop-nav__header" v-if="user && isLogged">
            <v-list-item>
              <v-list-item-avatar class="navigation__avatar">
                <span v-if="user.name && user.surname">{{user.name.charAt(0) + user.surname.charAt(0)}}</span>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{user.name}} {{user.surname}}</v-list-item-title>
              </v-list-item-content>

              </v-list-item>

              <v-list-item @click="showProfile()" link>
                <v-list-item-title>My profile</v-list-item-title>
              </v-list-item>

              <v-list-item @click="changePassword()" link>
                <v-list-item-title>Change password</v-list-item-title> 
              </v-list-item>
              
              <v-divider></v-divider>
              <v-list-item @click="showPersonalisationTests()" link>
                <v-list-item-title>My personalisation</v-list-item-title> 
              </v-list-item>
              <v-divider></v-divider>    

              <v-list-item @click="showUserMessages()" link>
                <v-list-item-title>My messages</v-list-item-title> 
              </v-list-item>

              <v-list-item link>
                <v-list-item-title @click="showUserQuestionaires()">My questionaires</v-list-item-title> 
              </v-list-item>

<!--               <v-list-item @click="showCognitiveTests()" link>
                <v-list-item-title>My cognitive tests</v-list-item-title> 
              </v-list-item> -->

              <v-divider></v-divider>

              <v-list-item @click="showLeaderBoard()" link>
                <v-list-item-title>Leader board</v-list-item-title>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item @click="showGroups()" link>
                <v-list-item-title>Groups</v-list-item-title>
              </v-list-item>

              <v-list-item @click="showTeacherDashboard()" link>
                <v-list-item-title>Teacher Dashboard</v-list-item-title>
              </v-list-item>

          </v-list>
          
          <v-divider></v-divider>

          <v-list v-if="isAdmin">
            <v-list-item @click="showQuestionaires()" link>
              <v-list-item-title>Questionaires</v-list-item-title>
            </v-list-item>

            <v-list-item @click="showMessages()" link>
              <v-list-item-title>Messages</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>
            
            <v-list-item @click="ShowActivity()" link>
              <v-list-item-title>System activity</v-list-item-title>
            </v-list-item>

            <v-list-item @click="ShowKernels()" link>
              <v-list-item-title>Show Kernels</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>
          </v-list>

          <v-card-actions>            
            <v-btn @click="logout" width = "100%" color="primary" text>Logout</v-btn>
          </v-card-actions>
        </v-card>
    </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="mobileNavigation" v-if="isLogged" temporary class="mobile-navigation__content">
      <v-list class="desktop-nav__header" v-if="user && isLogged">
            <v-list-item>
              <v-list-item-avatar class="navigation__avatar">
                    <span v-if="user.name && user.surname">{{user.name.charAt(0) + user.surname.charAt(0)}}</span>
              </v-list-item-avatar>

              <v-list-item-content>
                    <v-list-item-title>{{user.name}} {{user.surname}}</v-list-item-title>
              </v-list-item-content>

            </v-list-item>
      </v-list>

       <v-list-item class="vertically-horizontally-centered">
            <v-chip v-if="getUserPerformance && isLogged"
                class="ma-2"
                color="orange"
                text-color="white"
              >{{getUserPerformance.xp}} XP
            </v-chip>
        
            <v-chip v-if="getUserPerformance && isLogged"
                    class="ma-2"
                    color="orange"
                    text-color="white"
                  >
                  <v-icon left>tonality</v-icon>
                  {{getUserPerformance.coins}}          
            </v-chip>
      </v-list-item>
      <v-divider></v-divider>
      <v-list shaped> 
          <v-list-item link>
            <v-list-item-title @click="dashboard()" v-if="isLogged">DashBoard</v-list-item-title>
          </v-list-item>

          <v-list-item link>
            <v-list-item-title @click="categories()" v-if="isLogged">Course list</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>
          
          <v-list-item link>
            <v-list-item-title @click="showLeaderBoard()">Leader board</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

            <v-list-item link>
              <v-list-item-title @click="showProfile()">My profile</v-list-item-title>
            </v-list-item>

            <v-list-item link>
                <v-list-item-title @click="changePassword()">Change password</v-list-item-title> 
            </v-list-item>

          <v-divider></v-divider>
          
          <v-list-item link>
            <v-list-item-title @click="showTeacherDashboard()">Teacher Dashboard</v-list-item-title>
          </v-list-item>

          <v-list-item link>
            <v-list-item-title @click="showGroups()">Groups</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item link>            
            <v-list-item-title @click="logout">Logout</v-list-item-title> 
          </v-list-item>
      </v-list>
    </v-navigation-drawer>  

  </div>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      version: 'v. 2.820 - 2026-01-03',
      menu: false,
      mobileNavigation: false,
      initialised: false,
      typeStudentSwitch: true,
      logoThemeVersion: '',
    }
  },

  computed: 
        mapGetters([
                        'isLogged',
                        'isAdmin',
                        'getUserPerformance',
                        'user',
                        'getLanguageIcons',
                        'getThemePreference'
                    ])
  ,
  watch: {
      group () {
        this.mobileNavigation = false
      },
      getThemePreference: function() {
        this.changeThemeLogo();
      },
      isLogged: function() {
        this.changeThemeLogo();
      }
  },
  methods: {
    checkVersion() {
      return
  /*    this.initialised = true;
      axios.get('/get-version', this.$store.getters.getAxiosConfig)
          .then((res) => {
            if (res.data.version != this.version)
                this.$store.commit('setFeedback', 'Not current version. Please refresh web page.')
                this.$router.go() 
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          }) 
*/    },
    logout() { this.menu = false, this.$store.dispatch('logout') },
    register() { if (this.$router.currentRoute.name != 'register')
                    this.$router.push({name:'register', params: {}})  },
    login() { if (this.$router.currentRoute.name != 'login') 
                     this.$router.push({name:'login', params: {}})  },
    dashboard() { if (this.$router.currentRoute.name != 'dashboard')
                      this.$router.push({name:'dashboard', params: {}})  },   
    categories() { if (this.$router.currentRoute.name != 'categories')
                        this.$router.push({name:'categories', params: {}})  }, 
    showProfile() { 
      this.menu = false 
      if (this.$router.currentRoute.name != 'profile')
            this.$router.push({name:'profile', params: {}}) 
    },
    changePassword() { 
      this.menu = false       
      this.$router.push({name:'pwdchange', params: {}}) 
    },
    showUserMessages() {
      this.menu = false       
      this.$router.push({name:'message_list', params: {}}) 
    },
    showCognitiveTests() {
     // this.menu = false       
     // this.$router.push({name:'cognitive_tests', params: {}}) 
    },
    showPersonalisationTests() {
      this.menu = false       
      this.$router.push({name:'personalisation_tests', params: {}}) 
    },

    showUserQuestionaires() {
      this.menu = false       
      this.$router.push({name:'myquestionnaires', params: {}}) 
    },
    showLeaderBoard() {
      this.menu = false 
      this.$router.push({name:'leaderboard', params: {}}) 
    },
    showTeacherDashboard() {
      this.menu = false 
      this.$router.push({name:'teacher_dashboard', params: {}}) 
    },
    showGroups() {
      this.menu = false 
      this.$router.push({name:'groups', params: {}}) 
    },
    ShowActivity() {
      this.menu = false 
      this.$router.push({name:'users_activity', params: {}}) 
    },
    ShowKernels() {
      this.menu = false 
      this.$router.push({name:'show_kernels', params: {}}) 
    },
    showQuestionaires() {
      this.menu = false 
      this.$router.push({name:'que_list', params: {}}) 
    },
    showMessages() {
      this.menu = false 
      this.$router.push({name:'message_admin_list', params: {}}) 
    },
    priscilla() { 
      if (this.isLogged) {
         if (this.$router.currentRoute.name != 'dashboard')
               this.$router.push({name:'dashboard', params: {}})  
      } else {
          if (this.$router.currentRoute.name != 'login')
              this.$router.push({name:'login', params: {}})  
      }
    },
    langClick(lang)  {
      this.$store.commit('setFeedback', null)
      const data = { lang: lang}
      // get category list
      axios.post('/change-user-language', data, this.$store.getters.getAxiosConfig)
          .then((res) => {
            this.$store.commit('setUserLanguage', res.data.lang_id)
            this.$router.go() 
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          }) 
    },
    getLanguageURL() {
      for(let i = 0; i < this.getLanguageIcons.length; i++) {
        if (this.getLanguageIcons[i].id == this.user.lang_id)
           return this.getLanguageIcons[i].url
      }
      return "";
    },
    getLanguageTitle() {
      for(let i = 0; i < this.getLanguageIcons.length; i++) {

        if (this.getLanguageIcons[i].id == this.user.lang_id)
           return this.getLanguageIcons[i].title
      }
      return "";
    },
    changeThemeLogo() {
      if(this.isLogged == true) {
        if(this.getThemePreference == 'os-preference') {
            const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");

            if (prefersDarkScheme.matches) {
              this.logoThemeVersion = "-w"; 
            } else {
              this.logoThemeVersion = ""; 
            }

            // pokial je zvolena OS preferencia - kontrolujeme ci pocas behu nebola zmenena téma
            window.matchMedia('(prefers-color-scheme: dark)')
            .addEventListener('change', event => {
              if (event.matches) {
                this.logoThemeVersion = "-w"; 
              } else {
                this.logoThemeVersion = ""; 
              }
            })
        } else if(this.getThemePreference == 'dark') {
            this.logoThemeVersion = "-w"; 
        } else if(this.getThemePreference == 'light' || this.getThemePreference == 'colorblind') {
            this.logoThemeVersion = ""; 
        }
      } else {
        this.logoThemeVersion = ""; 
      }
    }
  },
  created() {
      this.changeThemeLogo()
  },
}

</script>

<style>
</style>
